var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3081 4.01855L32.4481 14.064V34.1549C32.4481 35.2645 31.5401 36.164 30.4201 36.164H10.1401C9.02003 36.164 8.11206 35.2645 8.11206 34.1549V6.02765C8.11206 4.91806 9.02003 4.01855 10.1401 4.01855H22.3081ZM20.2801 6.02765H10.1401V34.1549H30.4201V16.0731H22.3081C21.188 16.0731 20.2801 15.1736 20.2801 14.064V6.02765ZM22.3081 6.86142L29.5805 14.064H22.3081V6.86142Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7027 12.3289C15.8482 12.3289 16.7768 13.2488 16.7768 14.3836V15.2055H11.799V14.3836C11.799 13.2488 12.7276 12.3289 13.8731 12.3289H14.7027ZM14.2879 9.45222C14.9752 9.45222 15.5323 10.0042 15.5323 10.6851C15.5323 11.366 14.9752 11.9179 14.2879 11.9179C13.6006 11.9179 13.0434 11.366 13.0434 10.6851C13.0434 10.0042 13.6006 9.45222 14.2879 9.45222Z",
    fill: "#1B0076"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8027 17.8184H27.7573V20.4775H11.8027V17.8184Z",
    fill: "#1B0076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8027 22.2502H25.0982V24.9093H11.8027V22.2502Z",
    fill: "#1B0076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8027 26.6819H21.5527V29.341H11.8027V26.6819Z",
    fill: "#1B0076"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact-info.380d39e7506110370c2a0caaf5fb31d0.svg";
export { ForwardRef as ReactComponent };